<i18n src="./translations"></i18n>
<template>
  <div
    v-if="
      (information.signalWord || '') !== '' ||
      (information.icon || []).length !== 0 ||
      hasHazardStatements
    "
    class="hazardous-good-26"
  >
    <div class="signal-row">
      <span class="signal-word">{{
        information.signalWord || $t('hazardous-good-26.signal_word')
      }}</span>
      <div
        v-for="(name, index) in information.icon || []"
        :key="index"
        class="icon"
        :aria-label="$t(`hazardous-good-26.${name.toUpperCase()}`)"
        role="img"
      >
        <Icon :name="upperCamelCase(name)" aria-hidden="true" />
      </div>
    </div>

    <template v-if="hasHazardStatements">
      <span class="statements">
        <span class="headline"
          >{{ $t('hazardous-good-26.hazard_warning') }}
        </span>
        <span
          v-for="(statement, index) in information.statements.hazard"
          :key="index"
          class="statement"
        >
          {{ statement.label }}
        </span>
      </span>
    </template>

    <div
      v-for="(doc, index) in safetyDocuments"
      :key="'doc-' + index"
      class="safety-document-wrapper"
    >
      <a
        :href="doc.url"
        class="safety-document-card"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="hazardous-good-safety-document"
      >
        <Icon name="DocumentPdf" class="safety-document-card__icon" />
        <span class="safety-document-card__label">{{ doc.title }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import Icon from 'Components/00-generated/Icon';

export default {
  name: 'HazardousGood26',
  components: { Icon },
  props: {
    information: {
      type: Object,
      default: () => ({}),
    },
    documents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasHazardStatements() {
      return (
        this.information?.statements &&
        this.information.statements.hazard &&
        this.information.statements.hazard.length > 0
      );
    },
    safetyDocuments() {
      return this.documents.filter(
        (doc) => doc && doc.title === 'Sicherheitsdatenblatt'
      );
    },
  },
  methods: {
    upperCamelCase: (string) => upperFirst(camelCase(string)),
  },
};
</script>

<style lang="scss" scoped>
.hazardous-good-26 {
  margin-top: var(--hazardous-good-26-margin-top, var(--space-3));
  margin-bottom: var(--hazardous-good-26-margin-bottom, var(--space-3));

  .signal-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--space-1);
    margin-bottom: var(--space-1);
  }

  .signal-word {
    font-weight: bold;
    font-size: var(--font-size-M);
    color: var(--color-nero);
  }

  .icon {
    width: var(--hazardous-good-26-signal-icon-size, var(--space-5));
    height: var(--hazardous-good-26-signal-icon-size, var(--space-5));

    ::v-deep path:nth-of-type(1) {
      fill: var(--color-red);
    }
  }

  .statements {
    font-size: var(--font-size-S);
    color: var(--color-charcoal-gray);
    word-break: break-word;
  }

  .headline {
    font-weight: bold;
  }

  .statement {
    display: inline;

    &:not(:last-child)::after {
      content: ' ';
    }
  }

  .safety-document-wrapper {
    margin-top: var(--space-1);
  }

  .safety-document-card {
    display: inline-flex;
    align-items: center;
    gap: var(--space-1--half);
    padding: var(--space-1--half) var(--space-2);
    border: 1px solid var(--color-concrete);
    border-radius: var(--space-0--half);
    text-decoration: none;
    color: var(--color-nero);

    &:hover {
      border-color: var(--color-secondary);

      .safety-document-card__label {
        text-decoration: underline;
      }
    }

    &__icon {
      flex-shrink: 0;
      width: var(--space-3);
      height: var(--space-3);
    }

    &__label {
      font-size: var(--font-size-M);
      font-weight: bold;
    }
  }
}
</style>
